import {TOKEN_KEY} from 'core/constants';
import {isBrowserContext} from 'core/helpers';
import {softReload} from 'core/next/helpers';
import {TAppThunk} from 'core/redux/types';
import {CookieService} from 'core/services/CookieService';
import {actionLoaderSetHidden} from 'modules/loader/slice';
import {MODALS} from 'modules/modals/constants';
import {hideModal} from 'modules/modals/thunks';
import {actionSetUser} from 'modules/user/slice';
import {HOME_ROUTE} from 'routing/constants';

import {actionSetVkAuthUrl, actionSetYandexAuthUrl} from '../slice';

export const getPublicToken: TAppThunk<string | null> = async (_d, _g, {authenticationService}) => {
    const token = await authenticationService.getToken();

    const cookieService = CookieService.getInstance();

    if (token) {
        cookieService.setItem(TOKEN_KEY, token);
    }

    return token;
};

export const updateToken: TAppThunk<string> = async (_d, _g, {authenticationService, cookieService}) => {
    const updatedToken = await authenticationService.updateToken();

    if (updatedToken) {
        await cookieService.setItem(TOKEN_KEY, updatedToken);
        return updatedToken;
    }

    throw new Error('Update token API method returns invalid token!');
};

export const replaceByPublicToken =
    (token: string | null): TAppThunk<void> =>
    async (dispatch, _, {cookieService}) => {
        if (token) {
            await cookieService.removeItem(TOKEN_KEY);
            await cookieService.setItem(TOKEN_KEY, token);
        }

        dispatch(actionSetUser(null));
        dispatch(hideModal(MODALS.PRODUCT_SUBSCRIPTION_AUTH.name));
        dispatch(actionLoaderSetHidden(actionSetUser.type));
    };

export const authLogout: TAppThunk<void> = async (dispatch, _, {authenticationService}) => {
    const publicToken = await authenticationService.authLogout();

    await dispatch(replaceByPublicToken(publicToken));

    if (isBrowserContext() && publicToken) {
        await softReload(HOME_ROUTE);
    }
};

export const flushToken: TAppThunk<string> = async (dispatch, _, {authenticationService}) => {
    const publicToken = await authenticationService.getToken();

    const cookieService = CookieService.getInstance();

    if (!publicToken) {
        throw new Error('Get guest method API return invalid token!');
    }

    await dispatch(replaceByPublicToken(publicToken));
    cookieService.setItem(TOKEN_KEY, publicToken);

    return publicToken;
};

export const getYandexAuthUrl: TAppThunk<void> = async (dispatch, _, {authenticationService}) => {
    const result = await authenticationService.getYandexAuthUrl();

    dispatch(actionSetYandexAuthUrl(result.data.data.auth_url));
};

export const loginByYandexToken =
    (accessToken: string): TAppThunk<void> =>
    async (_d, _g, {authenticationService}) => {
        const token = await authenticationService.loginByYandexToken(accessToken);

        if (!token) {
            return;
        }

        const cookieService = CookieService.getInstance();

        cookieService.setItem(TOKEN_KEY, token);

        if ('undefined' !== typeof window) {
            const cleanUrl = window.location.origin + window.location.pathname;

            window.history.replaceState(null, '', cleanUrl);
        }
    };

export const getVkAuthUrl: TAppThunk<void> = async (dispatch, _, {authenticationService}) => {
    const result = await authenticationService.getVkAuthUrl();

    dispatch(actionSetVkAuthUrl(result.data.data.auth_url));
};
